import React, { useState } from 'react';

import { useSelector } from 'react-redux'

import { useObjectSelector, getObject  } from '../redux/hooks'
import { update } from '../redux/reducers'

import { useDispatch } from 'react-redux'

import Movie from './Movie';


function MovieExisting(props) {
    const dispatch = useDispatch()
    const objectId = "/api/movies/" + props.movieId+ "/"
    const movieSelector = useObjectSelector(objectId)
    const movie = getObject(objectId, movieSelector, dispatch)
    
    const [objectInputState, setObjectInputState] = useState()

    const startEdit = () => {
        setObjectInputState(movie())
        setEditState("EDIT")
    }

    const [editState, setEditState] = useState('READ') //EDIT ; 
    const [updateConclusionState, setUpdateConclusionState] = useState('NONE')  

    const startSave = () => {
        dispatch(update(objectId, objectInputState, (result)=>{
            console.log("callback ! result : "+JSON.stringify(result))
            setUpdateConclusionState(result)
            if (result.status==="fulfilled") 
                setEditState("READ")
        }))
        setUpdateConclusionState("UPDATEPENDING")
    }

    const startCancel = () => {
        setUpdateConclusionState("NONE")
        setEditState("READ")
    }

    const loginState = useSelector(store => store.loginReducer)




    return ( 
        editState === "READ" ?
        <Movie
        modifiable={loginState.logged}

        movie={movie}

        editState={editState}
        updateConclusionState={updateConclusionState}

        startEdit={startEdit}
    />

    :

    <Movie
        loginState={loginState}

        objectInputState={objectInputState}
        setObjectInputState={setObjectInputState}

        editState={editState}
        updateConclusionState={updateConclusionState}

        startSave={startSave}
        startCancel={startCancel}

    />

    
    )
}

export default MovieExisting